import React, { useState, useEffect } from "react";
import { Modal, Button, Container } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import VerificaToken from "./VerificaToken";

function NotificheButton() {
  const { user, setUser } = VerificaToken();
  const [show, setShow] = useState(false);
  const [notifiche, setNotifiche] = useState([]);
  let history = useHistory();

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  useEffect(() => {
    axios
      .get(
        `https://website-8bit-motors.herokuapp.com/notifiche/richiediNotifiche/${user.id}`
      )
      .then((response) => {
        setNotifiche(response.data);
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  }, []);

  const cancellaNotifiche = () => {
    axios
      .delete(
        `https://website-8bit-motors.herokuapp.com/notifiche/cancellaNotifiche/${user.id}`
      )
      .then(() => {
        history.go(0);
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  };

  return (
    <>
      <Button id="accountButton">
        <svg
          style={{ width: "2.5rem", height: "2.5rem" }}
          onClick={handleShow}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-bell"
          viewBox="0 0 16 16"
        >
          <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />
        </svg>
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Notifiche</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {notifiche.map((value, key) => {
            return (
              <Container className="notifica" fluid key={key}>
                {value.descrizione ===
                  "Sei in ritardo nella consegna del veicolo!" && (
                  <Link
                    className="link"
                    to={`http://localhost:3000/prenotazioni/Ritardo/${user.id}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="2rem"
                      height="2rem"
                      fill="currentColor"
                      class=" bi-bell-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
                    </svg>
                    <h3>{value.descrizione}</h3>
                    <p>{value.createdAt}</p>
                    ____________________________________________________________________
                  </Link>
                )}

                {value.descrizione ===
                  "Il tuo veicolo è stato appena consegnato." && (
                  <Link
                    className="link"
                    to={`/prenotazioni/ListaPrenotazioni/${user.id}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="2rem"
                      height="2rem"
                      fill="currentColor"
                      class=" bi-bell-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
                    </svg>
                    <h3>{value.descrizione}</h3>
                    <p>{value.createdAt}</p>
                    ____________________________________________________________________
                  </Link>
                )}

                {value.descrizione !==
                  "Il tuo veicolo è stato appena consegnato." &&
                  value.descrizione !==
                    "Sei in ritardo nella consegna del veicolo!" && (
                    <Container>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="2rem"
                        height="2rem"
                        fill="currentColor"
                        class=" bi-bell-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z" />
                      </svg>
                      <h3>{value.descrizione}</h3>
                      <p>{value.createdAt}</p>
                      __________________________________________________________________
                    </Container>
                  )}
              </Container>
            );
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={cancellaNotifiche}>
            Cancella Notifiche
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NotificheButton;
